import { enableOutOfTheBoxRoles } from '@gonfalon/dogfood-flags/dogfood-flags';

import type { CustomRole } from '../internal/types';

export function getAllRoleStatements(role: CustomRole) {
  if (enableOutOfTheBoxRoles()) {
    return [...role.policy, ...(role._presetStatements || [])];
  }

  return role.policy;
}
